import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "au-shell" }
const _hoisted_2 = { class: "au-main" }
const _hoisted_3 = { class: "au-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuthSidebar = _resolveComponent("AuthSidebar")!
  const _component_AuthNavbar = _resolveComponent("AuthNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthFooter = _resolveComponent("AuthFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AuthSidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AuthNavbar),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_AuthFooter)
    ])
  ]))
}